// import logo from './logo.svg';
import './App.css'
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import React, { Suspense, lazy, useEffect, useContext } from 'react';
import { LoginContext } from './components/ContextProvider/Context';
import ScrollToTop from './components/layout/ScrollToTop';
import Footer from'./components/layout/Footer';
import { loadFacebookPixel, loadGoogleAnalytics } from './utils/headScripts';

const Home = lazy(() => import('./components/pages/Home/Home'));
const About = lazy(() => import('./components/pages/About/About'));
const Patch = lazy(() => import('./components/pages/Patch/Patch'));
const Digitizing = lazy(() => import('./components/pages/Digitizing/Digitizing'));
const Vector = lazy(() => import('./components/pages/Vector/Vector'));
const Pricing = lazy(() => import('./components/pages/Pricing/Pricing'));
const Contact = lazy(() => import('./components/pages/ContactUs/Contact'));
const Login_1 = lazy(() => import('./components/pages/User/Login_1'));
const Register_1 = lazy(() => import('./components/pages/User/Register_1'));
const PasswordReset = lazy(() => import('./components/pages/User/PasswordReset'));
const Error = lazy(() => import('./components/pages/User/Error'));
const ForgotPassword = lazy(() => import('./components/pages/User/ForgotPassword'));
const UserProfile = lazy(() => import('./components/pages/userDashboard/profile/UserProfile'));
const DigitizingOrder = lazy(() => import('./components/pages/userDashboard/digitizing/DigitizingOrder'));
const DigitizingQuote = lazy(() => import('./components/pages/userDashboard/digitizing/DigitizingQuote'));
const PatchOrder = lazy(() => import('./components/pages/userDashboard/patch/PatchOrder'));
const PatchQuote = lazy(() => import('./components/pages/userDashboard/patch/PatchQuote'));
const PatchQuoteRecord = lazy(() => import('./components/pages/userDashboard/patch/PatchQuoteRecord'));
const PatchOrderRecord = lazy(() => import('./components/pages/userDashboard/patch/PatchOrderRecord'));


const VectorOrder = lazy(() => import('./components/pages/userDashboard/vector/VectorOrder'));
const VectorQuote = lazy(() => import('./components/pages/userDashboard/vector/VectorQuote'));
const SingleRecordDetails = lazy(() => import('./components/pages/userDashboard/patch/SingleRecordDetails'));
const Admindashboard = lazy(() => import('./components/pages/AdminDashboard/Admindashboard'));
const Users = lazy(() => import('./components/pages/AdminDashboard/Users'));
const UserProfileInAdmin = lazy(() => import('./components/pages/AdminDashboard/UserProfileInAdmin'));
const UserDashInAdmin = lazy(() => import('./components/pages/AdminDashboard/UserDashInAdmin'));
const TodayOrders = lazy(() => import('./components/pages/AdminDashboard/TodayOrders'));
const TodayQuotes = lazy(() => import('./components/pages/AdminDashboard/TodayQuotes'));
const DigitizingOrderRecords = lazy(() => import('./components/pages/userDashboard/digitizing/DigitizingOrderRecords'));
const DigitizingQuoteRecords = lazy(() => import('./components/pages/userDashboard/digitizing/DigitizingQuoteRecords'));
const VectorOrderRecords = lazy(() => import('./components/pages/userDashboard/vector/VectorOrderRecords'));
const VectorQuoteRecords = lazy(() => import('./components/pages/userDashboard/vector/VectorQuoteRecords'));
const SinglePatchQuoteDetails = lazy(() => import('./components/pages/userDashboard/patch/SinglePatchQuoteDetails'));
const SingleDigitizOrderDetails = lazy(() => import('./components/pages/userDashboard/digitizing/SingleDigitizOrderDetails'));
const SingleDigitizQuoteDetails = lazy(() => import('./components/pages/userDashboard/digitizing/SingleDigitizQuoteDetails'));
const SingleVectorQuoteDetails = lazy(() => import('./components/pages/userDashboard/vector/SingleVectorQuoteDetails'));
const SingleVectorOrderDetails = lazy(() => import('./components/pages/userDashboard/vector/SingleVectorOrderDetails'));
const ReleaseDigitizingOrder = lazy(() => import('./components/pages/AdminDashboard/ReleaseDigitizingOrder'));
const ReleasedOrders = lazy(() => import('./components/pages/AdminDashboard/ReleasedOrders'));
const ReleaseVectorOrder = lazy(() => import('./components/pages/AdminDashboard/ReleaseVectorOrder'));
const ReleasePatchOrder = lazy(() => import('./components/pages/AdminDashboard/ReleasePatchOrder'));

const SinglRelVectorOrdDetail = lazy(() => import('./components/pages/AdminDashboard/SinglRelVectorOrdDetail'));
const SinglRelPatchOrdDetail = lazy(() => import('./components/pages/AdminDashboard/SinglRelPatchOrdDetail'));
const SinglRelDigitOrdDetail = lazy(() => import('./components/pages/AdminDashboard/SinglRelDigitOrdDetail'));

const SinglRelVectorQuoteDetail = lazy(() => import('./components/pages/AdminDashboard/SinglRelVectorQuoteDetail'));
const SinglRelPatchQuoteDetail = lazy(() => import('./components/pages/AdminDashboard/SinglRelPatchQuoteDetail'));
const SinglRelDigitQuoteDetail = lazy(() => import('./components/pages/AdminDashboard/SinglRelDigitQuoteDetail'));

const ReleaseDigitizingQuote = lazy(() => import('./components/pages/AdminDashboard/ReleaseDigitizingQuote'));
const ReleaseVectorQuote = lazy(() => import('./components/pages/AdminDashboard/ReleaseVectorQuote'));
const ReleasePatchQuote = lazy(() => import('./components/pages/AdminDashboard/ReleasePatchQuote'));
const ReleasedQuotes = lazy(() => import('./components/pages/AdminDashboard/ReleasedQuotes'));
const InvocesRecords = lazy(() => import('./components/pages/AdminDashboard/InvocesRecords'));
const InvoicesCustomer = lazy(() => import('./components/pages/userDashboard/InvoicesCustomer'));
const NaviBar = lazy(() => import('./components/layout/NaviBar')) ;

const AdminNav = lazy(() => import('./components/pages/AdminDashboard/AdminNav'));
const DashNav = lazy(() => import('./components/pages/userDashboard/DashNav'));
const UsrDashboard = lazy(() => import('./components/pages/userDashboard/UsrDashboard'));
const Portfolio = lazy(() => import('./components/pages/portfolio/Portfolio'));


function RouteTracker() {
  const location = useLocation();

  useEffect(() => {

    if (window.fbq) {
      window.fbq('track', 'PageView');
    }

    if (window.gtag) {
      window.gtag('config', 'G-D02PLBJZ73', {
        page_path: location.pathname,
      });
    }

  }, [location]);

  return null;
}


function App() {
  // Head Scripts Start////////////
  useEffect(() => {

    const handleLoad = () => {
      loadFacebookPixel();
      loadGoogleAnalytics();
    };

    if (document.readyState === "complete") {
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);
    }

    return () => {
      window.removeEventListener("load", handleLoad);
    };

  }, []);
  // Head Scripts end////////////

    //////////////////////Tawk Button/////////////////////////////
  useEffect(() => {
  const timer = setTimeout(() => {
    if (document.getElementById("tawk-script")) return;

    const script = document.createElement("script");
    script.src = "https://embed.tawk.to/66fb2570e5982d6c7bb6d00a/1i92gkgou";
    script.async = true;
    script.id = "tawk-script";
    document.body.appendChild(script);
  }, 5000);

  return () => clearTimeout(timer);
}, []);
  
  //tawk Button End

  const { logindata } = useContext(LoginContext);
  var navbar 
  if (logindata) {
    switch (logindata.isAdmin) {
      case true:
        navbar = 'admin'
        break;
      case false:
        navbar = 'user'
        break;
    
      default:
        navbar = 'navibar'
        break;
    }
    
  } else {
    navbar = 'navibar'
  }
  return (
    <>
    <Router>
      <RouteTracker/>
      <ScrollToTop/>
      {navbar === 'admin'? <AdminNav/>:navbar === 'user' ? <DashNav/> :navbar === 'navibar' ? <NaviBar/>: <NaviBar/>}
        <Routes>
          {/* ///////////////General Routes////////////////// */}
        <Route path='/' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/patch' element={<Patch />} />
        <Route path='/digitizing' element={<Digitizing />} />
        <Route path='/vector'element={<Vector />} />
        <Route path='/pricing'element={<Pricing />} />
        <Route path='/portfolio'element={<Portfolio />} />
        <Route path='/Contact' element={<Contact />} />
        <Route path='login_1' element={<Login_1 />} />
        <Route path='register_1' element={<Register_1 />} />
        <Route path="*" element={<Error />} />
        <Route path="/password-reset" element={<PasswordReset />} />
        <Route path="/forgotpassword/:id/:token" element={<ForgotPassword />} />

            {/* /////////////////ADMIN ROUTES///////////////// */}
            <Route path='/adminDashboard' element={<Admindashboard />} />
            <Route path='/users' element={<Users />} />
            <Route path='/userProfileInAdmin/:id/:cName' element={<UserProfileInAdmin />} />
            <Route path='/userDashboard/:id/:cName' element={<UserDashInAdmin />} />
            <Route path='/placepatchorder/:id/:cName' element={<PatchOrder />}  />
            <Route path='/patchquote/:id/:cName' element={<PatchQuote />}  />
            <Route path='/placedigitizingorder/:id/:cName' element={<DigitizingOrder />}  />
            <Route path='/digitizingquote/:id/:cName' element={<DigitizingQuote />}  />
            <Route path='/placevectororder/:id/:cName' element={<VectorOrder />}  />
            <Route path='/vectorquote/:id/:cName' element={<VectorQuote />}  />
            <Route path='/todayOrders' element={<TodayOrders />} />
            <Route path='/todayQuotes' element={<TodayQuotes />} />
            <Route path='/releasedOrders' element={<ReleasedOrders />} />
            <Route path='/releasedQuotes' element={<ReleasedQuotes />} />
            <Route path='/invoicesRecords' element={<InvocesRecords />} />
            <Route path='/invoicesCustomer' element={<InvoicesCustomer />} />
            <Route path='/invoicesCustomer/:id/:cName' element={<InvoicesCustomer />} />

            <Route path='/releaseDigitizingOrder/:id/:priceDetails/:Cname/:Cemail' element={<ReleaseDigitizingOrder />} />
            <Route path='/releaseVectorOrder/:id/:priceDetails/:Cname/:Cemail' element={<ReleaseVectorOrder />} />
            <Route path='/releasePatchOrder/:id/:priceDetails/:Cname/:Cemail' element={<ReleasePatchOrder />} />
            
            <Route path='/singlRelDigitOrdDetail/:id' element={<SinglRelDigitOrdDetail />} />
            <Route path='/singlRelVectorOrdDetail/:id' element={<SinglRelVectorOrdDetail />} />
            <Route path='/singlRelPatchOrdDetail/:id' element={<SinglRelPatchOrdDetail />} />

            <Route path='/singlRelDigitQuoteDetail/:id' element={<SinglRelDigitQuoteDetail />} />
            <Route path='/singlRelVectorQuoteDetail/:id' element={<SinglRelVectorQuoteDetail />} />
            <Route path='/singlRelPatchQuoteDetail/:id' element={<SinglRelPatchQuoteDetail />} />

            <Route path='/releaseDigitizingQuote/:id/:priceDetails/:Cname/:Cemail' element={<ReleaseDigitizingQuote />} />
            <Route path='/releaseVectorQuote/:id/:priceDetails/:Cname/:Cemail' element={<ReleaseVectorQuote />} />
            <Route path='/releasePatchQuote/:id/:priceDetails/:Cname/:Cemail' element={<ReleasePatchQuote />} />


            {/* /////////////////USER ROUTES///////////////// */}
              <Route path='/userdashboard' element={<UsrDashboard />}  />
              <Route path='/userprofile' element={<UserProfile />}  />
              <Route path='/placepatchorder' element={<PatchOrder />}  />
              <Route path='/patchquote' element={<PatchQuote />}  />
              <Route path='/placedigitizingorder' element={<DigitizingOrder />}  />
              <Route path='/digitizingquote' element={<DigitizingQuote />}  />
              <Route path='/placevectororder' element={<VectorOrder />}  />
              <Route path='/vectorquote' element={<VectorQuote />}  />
              <Route path='/digitizingorderrecord/:id/:costumerName' element={<DigitizingOrderRecords />}  />
              <Route path='/digitizingquoterecord/:id/:costumerName' element={<DigitizingQuoteRecords />}  />
              <Route path='/vectororderrecord/:id/:costumerName' element={<VectorOrderRecords />}  />
              <Route path='/vectorquoterecord/:id/:costumerName' element={<VectorQuoteRecords />}  />
              <Route path='/patchorderrecord/:id/:costumerName' element={<PatchOrderRecord />}  />
              <Route path='/patchquoterecord/:id/:costumerName' element={<PatchQuoteRecord />}  />
              
              <Route path='/digitizingorderrecord' element={<DigitizingOrderRecords />}  />
              <Route path='/digitizingquoterecord' element={<DigitizingQuoteRecords />}  />
              <Route path='/vectororderrecord' element={<VectorOrderRecords />}  />
              <Route path='/vectorquoterecord' element={<VectorQuoteRecords />}  />
              <Route path='/patchorderrecord' element={<PatchOrderRecord />}  />
              <Route path='/patchquoterecord' element={<PatchQuoteRecord />}  />

              
              <Route path='/singleRecordDetails/:id' element={<SingleRecordDetails />}  />
              <Route path='/singlePatchQuoteDetails/:id' element={<SinglePatchQuoteDetails />}  />
              <Route path='/singleDigitizingOrderDetails/:id' element={<SingleDigitizOrderDetails />}  />
              <Route path='/singleDigitizingQuoteDetails/:id' element={<SingleDigitizQuoteDetails />}  />

              <Route path='/singleVectorOrderDetails/:id' element={<SingleVectorOrderDetails />}  />
              <Route path='/singleVectorQuoteDetails/:id' element={<SingleVectorQuoteDetails />}  />
              
        </Routes>
      <Footer/>
    </Router>
    </>
  );
}

export default App;